import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g>
      <path
        d="M4,3 C3.44771525,3 3,3.44771525 3,4 L3,12 C3,12.5522847 3.44771525,13 4,13 L12,13 C12.5522847,13 13,12.5522847 13,12 L13,4 C13,3.44771525 12.5522847,3 12,3 L4,3 Z M14,11 L14,12 C14,13.1045695 13.1045695,14 12,14 L11,14 L11,16 L10,16 L10,14 L8.5,14 L8.5,16 L7.5,16 L7.5,14 L6,14 L6,16 L5,16 L5,14 L4,14 C2.8954305,14 2,13.1045695 2,12 L2,11 L0,11 L0,10 L2,10 L2,8.5 L0,8.5 L0,7.5 L2,7.5 L2,6 L0,6 L0,5 L2,5 L2,4 C2,2.8954305 2.8954305,2 4,2 L5,2 L5,0 L6,0 L6,2 L7.5,2 L7.5,0 L8.5,0 L8.5,2 L10,2 L10,0 L11,0 L11,2 L12,2 C13.1045695,2 14,2.8954305 14,4 L14,5 L16,5 L16,6 L14,6 L14,7.5 L16,7.5 L16,8.5 L14,8.5 L14,10 L16,10 L16,11 L14,11 Z"/>
      <rect width="6" height="6" x="5" y="5" rx="1"/>
    </g>
  </svg>
);
